import React, {useEffect, useState} from "react";
import adminUsersApi from "../../../api/adminUsers";
import AdminUserTable from "./AdminUserTable";
import Loader from "../../../components/Loader";

export default function AdminUserTableHandler() {
    //get data from api
    const [user, setUser] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const response = await adminUsersApi.getAllUsers();
        if (response.ok) {
            setUser(response.data.users);
        }
    };

    //laat tabel zien met gegevens via props
    if (user.length > 0) return <AdminUserTable user={user}/>;
    return <Loader/>
}
